import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {Partners} from '../../../models/PartnersModel';
import {PartnerService} from '../../../services/partner.service';
import {filter, takeUntil, tap} from 'rxjs/operators';
import {DEFAULT_TESTIMONIALS} from '../../../models/CarouselConfigs';
import {ViewportService} from '../../../services/viewport.service';
import {Subject} from 'rxjs';

@Component({
    selector: 'testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit, OnDestroy {
    partner: Partners;
    numVisible: number;
    playingVideoTestimonial: any | null = null;
    private destroy$ = new Subject<void>();

    testimonials = DEFAULT_TESTIMONIALS

    constructor(
        private cdr: ChangeDetectorRef,
        private partnerService: PartnerService,
        public viewport: ViewportService
    ) {}

    ngOnInit(): void {
        this.partnerService.partner$.pipe(
            filter((partner) => !!partner),
            tap((partner) => {
                this.partner = partner;
            }),
            takeUntil(this.destroy$)
        ).subscribe({
            error: (err) => {
                console.error('Error loading partner data:', err);
            }
        });

        this.updateNumVisible(this.viewport.dimensions.width);
        this.viewport.dimensions$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(dimensions => {
            this.updateNumVisible(dimensions.width);
        });

        document.addEventListener('click', this.handleOutsideClick.bind(this))
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }

    updateNumVisible(screenWidth: number) {
        if (screenWidth < 768) {
            this.numVisible = 1;
        } else if (screenWidth < 1093) {
            this.numVisible = 2;
        }  else if (screenWidth < 1400) {
            this.numVisible = 3;
        } else {
            this.numVisible = 3;
        }
    }

    playVideo(testimonial: any, videoElement: HTMLVideoElement, event: Event) {
        event.stopPropagation();
        this.playingVideoTestimonial = testimonial;
        this.cdr.detectChanges();
        videoElement.play();
    }

    handleOutsideClick(event: Event) {
        this.playingVideoTestimonial = null;
        this.cdr.detectChanges();
    }




}
